import { Component, Input } from '@angular/core';
import { ValueRecognitionTableInfo } from '../../models/value-recognition-table-info.model';

@Component({
  standalone: false,
  selector: 'app-value-recognition-table',
  templateUrl: './value-recognition-table.component.html',
  styleUrls: ['./value-recognition-table.component.scss'],
})
export class ValueRecognitionTableComponent {
  @Input() readonly!: boolean;
  @Input() title!: string;
  @Input() tableInfo!: ValueRecognitionTableInfo;
  @Input() isUrgencyXVulnerability = false;
}
